import { Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import { IWorkInfoTableRow } from "./WorkInfoTableModel";

export const WorkInfoTableRow: React.FC<{
  row: IWorkInfoTableRow;
  dataAutomation?: string;
}> = ({
  row: {
    cells,
    tableCellHasColumns,
    isSubCategoryRow,
    isDisable,
    oddRow,
  },
  dataAutomation,
}) => {
    const oddClassName = oddRow ? 'oddRow' : '';
    const disabledClassName = isDisable ? 'disabled' : '';
    const subCategoryClassName = isSubCategoryRow ? 'subCategory' : '';
    return (
      <TableRow
        className={`${oddClassName} ${disabledClassName} ${subCategoryClassName}`}
        data-automation={`${isSubCategoryRow ? "subcat-" : ""}${dataAutomation ?? "tbl-row"}`}
      >
        {
          cells.map((cell, i) => (
            <TableCell key={i}>
              {
                tableCellHasColumns ? (
                  <Table>
                    <TableBody>
                      <TableRow>
                        {cell.map((cellItem, i) => (
                          <TableCell align={cellItem.align || 'left'} key={i}>{cellItem.children}</TableCell>
                        ))}
                      </TableRow>
                    </TableBody>
                  </Table>
                ) :
                  cell.map((cellItem, i) => (
                    <Typography sx={{ textAlign: cellItem.align || 'left', whiteSpace: 'nowrap' }} key={i}>{cellItem.children}</Typography>
                  ))
              }
            </TableCell>
          ))
        }
      </TableRow>
    )
  }